import { Box, useTheme } from '@mui/material';
import { flexCenter } from '../../../commonUI/cssClasses';
import MapOnboarding from './MapOnboarding';

interface Props {
  showBlockBoundaryPopupButton?: boolean;
}

const MapFormViewer: React.FC<Props> = ({
  showBlockBoundaryPopupButton = false,
}) => {
  const theme = useTheme();

  return (
    <Box
      sx={{
        width: '100%',
        height: '100%',
        mt: '1rem',
        bgcolor: theme.colors.darkTheme.grey.dark,
        border: `1px solid ${theme.colors.darkTheme.grey.muted}`,
        borderRadius: theme.borderRadius.primary,
        boxShadow:
          '0px 2px 1px -1px rgb(0 0 0 / 20%), 0px 1px 1px 0px rgb(0 0 0 / 14%), 0px 1px 3px 0px rgb(0 0 0 / 12%)',
      }}
    >
      <Box
        sx={{
          width: '100%',
          height: '100%',
          ...flexCenter,
          borderRadius: theme.borderRadius.primary,
          overflow: 'hidden',
        }}
      >
        <MapOnboarding
          showBlockBoundaryPopupButton={showBlockBoundaryPopupButton}
        />
      </Box>
    </Box>
  );
};

export default MapFormViewer;
